import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import { LedgerMode } from '../../../../appconfig';
import { VaultService } from '../../services/vault.service';
import { UserService } from '../../../services/common';
import { config } from 'rxjs';

@Component({
  selector: 'app-vault-ledger-view',
  templateUrl: './vault-ledger-view.component.html',
  styleUrl: './vault-ledger-view.component.scss'
})
export class VaultLedgerViewComponent implements OnInit {
  ledgerMode: any = LedgerMode.Vault
  ledgerAccountId: any = -1;
  isUserLedger: boolean = false;
  ledgerViewData: any;
  columnDefs: any[] = []
  userList: any[] = [];

  ledgerRequestObj: any = {
    accountId: this.ledgerAccountId,
    mode: this.ledgerMode,
    fromDate: new Date(new Date().setDate(new Date().getDate() - 30)),// this.fromDate,
    toDate: new Date(),
  }

  constructor(public commonService: CommonService, private vaultService: VaultService, private userService: UserService) { }

  ngOnInit(): void {
    this.getBasicUserList();
    this.initalizeColumnDefs();
    this.getLedgerViewData();
  }

  initalizeColumnDefs() {
    this.columnDefs = [
      { field: 'transDate', header: 'Date', columnType: 'date', config: { dateFormat: "dd-MMM-yyyy" } },
      { field: 'party', header: 'Description', columnType: 'text' },
      { field: 'debit', header: 'Debit', columnType: 'amount', config: { decimals: 3 } },
      { field: 'credit', header: 'Credit', columnType: 'amount', config: { decimals: 3 } },
    ]
  }

  getLedgerViewData() {
    //sets date in request object to date format only
    this.ledgerRequestObj.fromDate = this.commonService.toDateOnly(this.ledgerRequestObj.fromDate);
    this.ledgerRequestObj.toDate = this.commonService.toDateOnly(this.ledgerRequestObj.toDate);

    this.vaultService.getLedger(this.ledgerRequestObj).subscribe((res: any) => {
      if (res) {
        this.ledgerViewData = res?.result;
        this.ledgerViewData.ledgerRows = this.ledgerViewData?.ledgerRows.map((item: any) => {
          return {
            ...item,
            debit: item?.amount < 0 ? -item?.amount : 0,
            credit: item?.amount > 0 ? item?.amount : 0,
            amount: item?.amount < 0 ? -item?.amount : item?.amount,
            party: (item?.accountDetails?.firstName == undefined ? '' : item?.accountDetails?.firstName)
              + (this.commonService.isNullUndefined(item?.accountDetails?.lastName) ? '' : ' ' + item?.accountDetails?.lastName)
              + ' ' + (item?.accountDetails?.firstName == undefined ? '' : ' (') + item?.remark +
              (item?.accountDetails?.firstName == undefined ? '' : ')'),
          }
        });
      }
    });
  }

  setSelectedUser(event: any) {
    this.getLedgerViewData();
  }

  getBasicUserList() {
    this.userService.getFilterBasicUser({ isactive: true }).subscribe((res: any) => {
      if (res) {
        this.userList = res?.result?.map((item: any) => {
          return {
            ...item,
            name: item?.initialDetails?.name + '. ' + item?.firstName + ' ' + item?.lastName,
          }
        });
      }
    });
  }

  toggleLedgerFor(event: any) {
    //reset current ledger view data on toggle
    this.ledgerViewData = null;

    if (event?.checked == true) {
      this.ledgerRequestObj.accountId = null;
    } else {
      this.ledgerRequestObj.accountId = -1;
      this.getLedgerViewData();
    }
  }
}
